import { useMutation } from '@apollo/client';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { REMOVE_USER } from './graphql';

const RemoveUser = ({ user }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { id } = useParams();

    const [removeUser, { loading }] = useMutation(REMOVE_USER);

    return (
        <>
            <Button
                size='xs'
                variant='outline'
                colorScheme='red'
                onClick={() => onOpen()}
                isDisabled={loading}
                isLoading={loading}
            >
                Remove User
            </Button>
            {isOpen && (
                <Modal isCentered isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalCloseButton />
                    <ModalContent>
                        <ModalHeader>Remove user</ModalHeader>
                        <ModalBody>
                            <Text mb='25px'>
                                Are you sure you want to remove{' '}
                                {user.first_name} {user.last_name} as an
                                administrator on this client?
                            </Text>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                colorScheme='red'
                                isDisabled={loading}
                                isLoading={loading}
                                onClick={() =>
                                    removeUser({
                                        variables: {
                                            user_id: user._id,
                                            client_id: id,
                                        },
                                        refetchQueries: ['GetClient'],
                                        onCompleted: () => onClose(),
                                    })
                                }
                            >
                                Remove user
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            )}
        </>
    );
};

export default RemoveUser;
